module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.9.2.0.box.0.1714.1756.16.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.9.2.0.box.0.1714.1756.16.q.101"
    }
  }, [_vm._v("RATTLE AND SNAP")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.9.3.0.box.0.1641.1756.105.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.9.3.0.box.0.1730.1756.16.q.101"
    }
  }, [_c('i', [_vm._v("1845")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.9.3.1.box.588.1641.573.32.q.70"
    }
  }, [_vm._v("Ten tall pillars and a game of \"beans\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.4.0.box.130.1725.1506.744.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.4.0.box.131.1725.1504.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.4.0.0"
    }
  }), _vm._v("\"Magnificent\" has to be the first word in any description of RATTLE AND SNAP. Though not the firstborn of the long line of Polk mansions to march across the Maury County countryside, RATTLE AND SNAP remains today far and away the crown prince of them all.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.4.1.box.131.1891.1502.120.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.4.1.0"
    }
  }), _vm._v("Conceived in the womb of a sincere love of sheer beauty, and nurtured in the lap of an age that could afford it, RATTLE AND SNAP stands in elegant tribute to that time long past when a craftsman's pride matched the might of his master's purse.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.4.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.4.2.box.131.2016.1504.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.4.2.0"
    }
  }), _vm._v("Though the great stone foundation of RATTLE AND SNAP is sunk deep in the loamy bosom of Middle Tennessee's heartland, the roots of its real beginnings and unique name reach all the way back to post-Revolutionary North Carolina and a bag of lowly beans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.4.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.4.3.box.130.2181.1506.288.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.4.3.0"
    }
  }), _vm._v("If not a great deal is known about Col. William Polk, the proof is in the pudding that he had, at least, three obvious talents—siring exceptional sons, buying up Revolutionary land grants from fellow veterans, and emerging victorious from a game of \"beans\" with the Governor of North Carolina's deed for 5,648 prime Maury County acres tucked neatly in his pocket. To this particular tract lying along the Columbia-Mt. Pleasant Pike the good Colonel attached a very appropriate and colorful sobriquet, RATTLE AND SNAP.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.10.0.0.box.830.0.923.1335.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0014.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.129.161.1504.2299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.0.box.132.161.635.281.q.40"
    }
  }, [_vm._v("When William Polk divided his RATTLE AND SNAP holdings among four of his sons—Lucius J., Leonidas, Rufus K., and George W. Polk—the latter, George, decided to retain the original name for his portion of his father's estate.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.131.457.635.707.q.60"
    }
  }, [_vm._v("After choosing for the site of his future mansion the brow of a commanding hillock deep within a dense woodland of giant oak, black walnut, and towering elm, George Polk purchased an additional 800 acres to the eastward of his RATTLE AND SNAP properties. Here he built \"The Cottage,\" a nine-room, one-story, \"unpretentious\" frame house. Within these walls would be born all but one of George and Sally Hilliard Polk's children. The Polks were still living at \"The Cottage\" in the early 1840's when work was begun on what their slaves soon came to refer to as \"The Big House.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.2.box.130.1170.1500.373.q.60"
    }
  }, [_vm._v("Never a man of half measures, George Polk seems to have been determined from the ver"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.4.0"
    }
  }), _vm._v("y beginning that RATTLE AND SNAP plantatio"), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.5.0"
    }
  }), _vm._v("n would be as self-sustaining as possible. To his own forests, he looked for the massive framing timbers that would span the walls built of brick fired in his own kilns. Upon his own shoulders, George Polk placed the burden of overseeing the workmanship, furnished almost entirely by his own skilled masons and carpenters.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.3.box.130.1549.1503.374.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.6.0"
    }
  }), _vm._v("Even as ground was being broken, George Polk—ever planning ahead—had sent across the wide Atlantic for the German landscape artist whose charge it would be to plan the winding walks, plant the many-acred lawns, vegetable and flower gardens, and beds of evergreen. All—from the five huge cisterns for watering the grounds to the three extensive greenhouses that would yield everything from violets to bananas—must stand in readiness at RATTLE AND SNAP'S completion. For Master Polk's \"open house\" his German gardener must see not only to turnips on the table but also that his herb beds sprouted spices like sage, thyme, and horseradish, and brought forth such early day medicinals as horehound, catnip flax and rhubarb.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.4.box.130.1928.1500.324.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.7.0"
    }
  }), _vm._v("Even this vast domain of such abundance had certain limits, however. To Italy George Polk was forced to turn for RATTLE AND SNAP'S exquisite marble mantels, while the great twenty-six foot Corinthian columns for the front veranda had to be shipped in sections from distant Cincinnati. They were first boated down the Ohio, thence up the Cumberland to Nashville, and, finally, ox-carted overland to the Polk plantation. In years to come, as the blue tide of the Federal army swept up from the southward, the smallest of George Polk's sons would lower the family silver into the hollow sanctuary of one of these mighty pillars.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.5.box.129.2257.1500.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.8.0"
    }
  }), _vm._v("Forever an outstanding feature of RATTLE AND SNAP'S outer grace and constant beauty, the grillwork of the east portico may well have been cast in the iron foundries of Pittsburgh, and yet there is an intricate delicacy here that suggests the Creole flavor of far New Orleans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.6.box.166.2424.1463.36.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("So sophisticated and "), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.0.0"
    }
  }), _vm._v("perfect too are RATTL"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.5.0.0"
    }
  }), _vm._v("E AND SNAP'S inte"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.7.0.0"
    }
  }), _vm._v("rior cornices and ceiling"), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.7.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.12.1.0.box.151.1423.1499.122.q.60"
    }
  }, [_vm._v("\nmedallions, there arises the distinct conviction that here, once again, George Polk was forced to thrust aside his pride and look beyond even his own bountiful realm for such meticulous care and dedicated artisanship.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.11.0.0.box.0.0.1637.1428.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.11.1.0.box.206.1448.1507.1214.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.5.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.0.0.box.150.0.1500.1224.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.6.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.151.1423.1500.329.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.151.1549.1500.203.q.60"
    }
  }, [_vm._v("Sometime in 1845, while cousin James Knox Polk was still warming the presidential chair in Washington, George Polk moved his family into magnificent RATTLE AND SNAP—a house that would stand in long tribute, not only to the mind that conceived it, but also to the skilled hands and constant pride that wove a man's dreams into a peerless reality of his age.")]), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.7.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.2.0.box.34.1911.1552.782.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.7.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0018.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.7.0.0.2"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.13.0.0.box.118.157.1539.1440.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0019.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cbd50da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0020.vue
// module id = 57
// module chunks = 0